<template>
  <div class="container__card order-card" id="card" style="text-align: center;">
    <div class="wrapper-position">
        <div id="brand-logo" class="brand-logo" v-if="brandLogo">
          <img :src="brandLogo" class="left-padding">
        </div>
      <div class="thank-you thank-you-content" id="new-user-thankyou-content">
        <p :style="themeColor">Thank you for subscribing</p>
        <button @click="close()">Close</button>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  export default {
    mounted() {
      var cardWrapper = document.querySelectorAll(".wrapper-position")[0];
      document.querySelectorAll(".order-card")[0].classList.add("translateCard");
    },
    methods: {
      close() {
        window.parent.postMessage("close", "*");
      }
    }
  }

</script>

<style scoped>
  .order-card {
    top: 30px;
    /*left: 100px;*/
    /*text-align: center;*/
    transform: translate(0,20%);
    width: 100%;
  }

  .wrapper-position {
    max-width: none;
  }
</style>


// WEBPACK FOOTER //
// ThankYouPage.vue?658ea703